const pushToNewRelic = (name: string, payload: any) => {
    if (typeof newrelic == 'object') {
        newrelic.addPageAction(name, {
            ...payload
        })
    }
}

export default pushToNewRelic
